const TEXT_INPUT_TYPES = ["text", "search", "tel", "url", "password"];
const INTERACTIVE_SELECTOR = "a, button, select, [role='button']";

export const getTextFieldForTarget = (
	target: EventTarget | null,
): HTMLInputElement | HTMLTextAreaElement | null => {
	if (!(target instanceof Element) || target.closest(INTERACTIVE_SELECTOR)) {
		return null;
	}

	const field = target.closest("label")?.control ?? target;
	if (
		field instanceof HTMLTextAreaElement ||
		(field instanceof HTMLInputElement && TEXT_INPUT_TYPES.includes(field.type))
	) {
		return field.readOnly || field.disabled ? null : field;
	}

	return null;
};
